module.exports = __webpack_public_path__ + "static/media/hello-peter.f3babcd3.svg";